// console.log("Hello");
if (window.location.href == "https://www.tamoorfans.com/collections/sale") {
   window.location.href = 'https://www.tamoorfans.com/'; 
}

/*
 document.addEventListener("DOMContentLoaded", function() {
    const images = document.querySelectorAll('img.gp-h-full');

    images.forEach(image => {
        const container = image.closest('.image-container');

        // Create the loading icon element
        const loadingIcon = document.createElement('div');
        loadingIcon.className = 'loading-icon';

        // Create the logo element
        const logo = document.createElement('img');
        logo.src = 'https://tamoorfans.myshopify.com/cdn/shop/files/Tamoor_Fans_Logo_red_1.png'; // Path to your logo image
        logo.alt = 'Loading';

        // Append the logo to the loading icon
        loadingIcon.appendChild(logo);

        // Insert the loading icon into the container
        container.appendChild(loadingIcon);

        // Show the image only after it's fully loaded
        image.addEventListener('load', function() {
            loadingIcon.style.display = 'none';
            image.style.display = 'block';
        });

        // In case of an error (e.g., image not found)
        image.addEventListener('error', function() {
            loadingIcon.style.display = 'none';
            // Optionally, show a placeholder or error message
        });

        // Start loading the image
        image.src = image.src;
    });
});
*/
